import React, { useEffect, useImperativeHandle, forwardRef } from 'react';
import s from './s.module.less';
import { Spin } from 'antd';
import PracticeFrontPreviewStore from 'store/PracticeFrontPreview';
import { Desktop } from 'assets/preview/Desktop';
import { Mobile } from 'assets/preview/Mobile';
import os from 'assets/preview/OS.svg';
import staticImage from './staticImage.png';

interface IProps {
    showStaticImage?: boolean;
    link?: string;
    onLoad?: (status: boolean) => void;
}

// 定义ref的方法接口
export interface PreviewRef {
    sendPreviewData: (data: { anchor: number; data: any }) => void;
}

const type = {
    getHeight: 'getHeight',
    refresh: 'refresh',
    returnHeight: 'returnHeight',
    previewLocalSEO: 'previewLocalSEO',
    showLocalSEO: 'showLocalSEO',
    previewContactForm: 'previewContactForm',
    updateServiceStateKey: 'updateServiceStateKey',
    updateServiceStateTypeKey: 'updateServiceStateTypeKey',
    // 新增preview相关的消息类型
    previewMedicationData: 'previewMedicationData',
};

const Preview = forwardRef<PreviewRef, IProps>(({ link, onLoad, showStaticImage = false }, ref) => {
    const [loading, setLoading] = React.useState(true);
    const [get, set] = PracticeFrontPreviewStore.useStore();
    const flag = get('flag');

    const isMobileMode = get('isMobile');
    const previewLocalSEO = get('previewLocalSEO');
    const showLocalSEO = get('showLocalSEO');
    const previewContactForm = get('previewContactForm');
    const serviceStateKey = get('serviceStateKey');
    const serviceStateTypeKey = get('serviceStateTypeKey');

    const [currentLink, setCurrentLink] = React.useState('');

    useEffect(() => {
        if (link) {
            setCurrentLink(`${link}?isPreview=true`);
        }
    }, [link]);

    // 向iframe发送medication数据的函数
    const sendPreviewData = React.useCallback((previewData: { anchor: number; data: any }) => {
        try {
            const pfIframe: any = document.getElementById('pf-preview');
            if (pfIframe && pfIframe.contentWindow) {
                const iframeWin = pfIframe.contentWindow;
                const message = {
                    type: type.previewMedicationData,
                    anchor: previewData.anchor,
                    data: previewData.data,
                };
                console.log('Sending preview data to iframe:', message);
                iframeWin.postMessage(message, '*');
            }
        } catch (e) {
            console.error('Error sending preview data:', e);
        }
    }, []);

    // 暴露方法给父组件
    useImperativeHandle(ref, () => ({
        sendPreviewData,
    }), [sendPreviewData]);

    const sendHeight = () => {
        try {
            const pfIframe: any = document.getElementById('pf-preview');
            const iframeWin = pfIframe.contentWindow;
            const message = {
                type: type.getHeight,
            };
            iframeWin.postMessage(message, '*');
        } catch (e) {
            console.error(e);
        }
    };

    const sendRefresh = () => {
        try {
            const pfIframe: any = document.getElementById('pf-preview');
            const iframeWin = pfIframe.contentWindow;
            const message = {
                type: type.refresh,
            };
            iframeWin.postMessage(message, '*');
            setTimeout(() => {
                sendHeight();
            }, 5000);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        const pfIframe: any = document.getElementById('pf-preview');
        // eslint-disable-next-line func-names
        pfIframe.onload = function () {
            onLoad?.(true);
            //获取 iframe 内容的高度
            setTimeout(() => {
                sendHeight();
            }, 5000);
        };
    }, []);

    useEffect(() => {
        if (flag) {
            sendRefresh();
        }
    }, [flag]);

    useEffect(() => {
        try {
            const pfIframe: any = document.getElementById('pf-preview');
            const iframeWin = pfIframe.contentWindow;
            const message = {
                type: type.showLocalSEO,
                data: showLocalSEO,
            };
            iframeWin.postMessage(message, '*');
            const message2 = {
                type: type.previewLocalSEO,
                data: previewLocalSEO,
            };
            iframeWin.postMessage(message2, '*');
            const message3 = {
                type: type.previewContactForm,
                data: previewContactForm,
            };
            iframeWin.postMessage(message3, '*');

            const message4 = {
                type: type.updateServiceStateKey,
                data: serviceStateKey,
            };
            iframeWin.postMessage(message4, '*');

            const message5 = {
                type: type.updateServiceStateTypeKey,
                data: serviceStateTypeKey,
            };
            iframeWin.postMessage(message5, '*');
        } catch (e) {
            console.error(e);
        }
    }, [previewLocalSEO, showLocalSEO, previewContactForm, serviceStateKey, serviceStateTypeKey]);

    return (
        <div className={s.wrap}>
            <div className={s.modeWrap}>
                <span
                    onClick={() => {
                        set('isMobile', false);
                    }}
                    className={isMobileMode ? '' : s.active}
                >
                    <Desktop />
                </span>
                <span
                    onClick={() => {
                        set('isMobile', true);
                    }}
                    className={isMobileMode ? s.active : ''}
                >
                    <Mobile />
                </span>

            </div>
            <div
                className={isMobileMode ? `${s.iframeWrap} ${s.iframeWrapMobile}` : s.iframeWrap}
            >
                <div className={s.topBar}>
                    <img src={os} />
                </div>
                {
                    showStaticImage ? (
                        <div className={s.staticImage}>
                            <img src={staticImage} />
                        </div>
                    ) : (
                        <Spin spinning={loading}>
                            <iframe
                                onLoad={() => {
                                    setLoading(false);
                                }}
                                src={currentLink}
                                scrolling="auto"
                                id="pf-preview"
                                title="preview"
                                className={s.iframe}
                            />
                        </Spin>
                    )
                }
            </div>
        </div>
    );
});

export default Preview;
